export default __webpack_public_path__ + "static/media/combined.e4aa668f.png";